<template>
  <tr>
    <td>{{ mentor.alumno.nombre }} {{ mentor.alumno.apellido }}</td>
    <td>{{ fecha(mentor.fecha_inicio) }}</td>
    <td>{{ mentor.condicion.nombre }}</td>
    <td class="botones_mesa_examen">
      <button @click="mostrarModalFinalizarMentoria()" class="boton_editar_password boton_editar_password_2">Finalizar</button>
      <div class="contenedor_editar_password"
        v-if="mostrarFinalizarMentoria"
      >
        <div class="contenedor_form_editar_password">
          <button class="cerrar_modal" @click="cerrarModalFinalizarMentoria()">X</button>
          <form
            action="#"
            @submit.prevent="editarMentoria(mentoria, mentor.mentoria_id)"
            class="form_editar_password"
            ref="modalRef"
          >
            <div class="form_section_editar_password contenedor-ojo">
              <label for="fecha_finalizacion">Fecha Finalización</label>
              <input
                type="date"
                name="fecha_finalizacion"
                id="fecha_finalizacion"
                v-model="mentoria.fecha_finalizacion"
              >
            </div>
            <div class="form_section_editar_password contenedor-ojo">
              <label for="password_nueva_confirmacion">Observaciones</label>
              <textarea
                name="comentario_final"
                id="comentario_final"
                v-model="mentoria.comentario_final"
              ></textarea>
            </div>
            <button type="submit">Finalizar Mentoría</button>
          </form>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
// import examenService from '../services/examen'
// import BaseLoader4 from '../components/BaseLoader4.vue'
export default {
  name: 'MentoriasAbiertasListaItem',
  components: {
    // BaseLoader4
  },
  props: ['mentor'],
  data: function () {
    return {
      mostrarFinalizarMentoria: false,
      mentoria: {
        fecha_finalizacion: null,
        comentario_final: null
      }
    }
  },
  methods: {
    fecha (fecha) {
      const year = fecha.slice(0, 4)
      const month = fecha.slice(5, 7)
      const day = fecha.slice(8, 10)
      return day + '/' + month + '/' + year
    },
    mostrarModalFinalizarMentoria () {
      this.mostrarFinalizarMentoria = true
      document.addEventListener('mouseup', this.closeModalOnClickOutside)
      // Pongo el body sin scroll
      const body = document.body
      body.style.overflow = 'hidden'
    },
    closeModalOnClickOutside (event) {
      const modal = this.$refs.modalRef
      console.log('aaaaaaa11111')
      console.log(modal)
      if (!modal.contains(event.target)) {
        console.log('wewewwewew')
        this.cerrarModalFinalizarMentoria()
      }
    },
    cerrarModalFinalizarMentoria () {
      console.log('222222')
      document.removeEventListener('mouseup', this.closeModalOnClickOutside)
      this.mostrarFinalizarMentoria = false
      // this.errores2 = {
      //   password_nueva: null,
      //   password_nueva_confirmacion: null
      // }
      // this.password = {
      //   password_nueva: null,
      //   password_nueva_confirmacion: null
      // }
      // saco el overflow del body
      const body = document.body
      body.style.overflow = 'auto'
    },
    editarMentoria (mentoria, id) {
      console.log(mentoria)
      console.log(id)
    }
  },
  mounted: function () {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.cerrarModalFinalizarMentoria()
      }
    })
  }
}
</script>

<style>

</style>
